import React from 'react'

import { headingStyling, heroHeading } from './HeadingComponent.module.css'

const HeadingComponent = ({
  children,
  extraClassName,
  heroHeader,
  withParagraph,
}) => {
  if (heroHeader) {
    return <h1 className={`${heroHeading} ${extraClassName}`}>{children}</h1>
  }
  if (withParagraph) {
    return <p className={`${headingStyling} ${extraClassName}`}>{children}</p>
  }
  return <h2 className={`${headingStyling} ${extraClassName}`}>{children}</h2>
}

export default HeadingComponent
